module.exports = __webpack_public_path__ + "static/img/vedioLeft.af0456ea.png";